var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.471293 8.03082C0.330842 7.8902 0.251953 7.69957 0.251953 7.50082C0.251953 7.30207 0.330842 7.11145 0.471293 6.97082L6.47129 0.970822C6.53996 0.897135 6.62275 0.838033 6.71475 0.797042C6.80675 0.75605 6.90607 0.734008 7.00677 0.732232C7.10747 0.730455 7.2075 0.748979 7.30089 0.7867C7.39428 0.824421 7.47911 0.880566 7.55033 0.951785C7.62155 1.023 7.67769 1.10784 7.71542 1.20123C7.75314 1.29461 7.77166 1.39464 7.76988 1.49534C7.76811 1.59605 7.74607 1.69536 7.70507 1.78736C7.66408 1.87936 7.60498 1.96216 7.53129 2.03082L2.81129 6.75082L17.0013 6.75082C17.2002 6.75082 17.391 6.82984 17.5316 6.97049C17.6723 7.11114 17.7513 7.30191 17.7513 7.50082C17.7513 7.69973 17.6723 7.8905 17.5316 8.03115C17.391 8.1718 17.2002 8.25082 17.0013 8.25082L2.81129 8.25082L7.53129 12.9708C7.60498 13.0395 7.66408 13.1223 7.70507 13.2143C7.74607 13.3063 7.76811 13.4056 7.76989 13.5063C7.77166 13.607 7.75314 13.707 7.71542 13.8004C7.67769 13.8938 7.62155 13.9786 7.55033 14.0499C7.47911 14.1211 7.39428 14.1772 7.30089 14.2149C7.2075 14.2527 7.10747 14.2712 7.00677 14.2694C6.90607 14.2676 6.80675 14.2456 6.71476 14.2046C6.62276 14.1636 6.53996 14.1045 6.47129 14.0308L0.471293 8.03082Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.4148409a6f9b5b52ce18ab4af645cc6b.svg";
export { ForwardRef as ReactComponent };